export default {
  skip_to_main_content: 'Перейти к основному содержанию',
  show_system_messages: 'Показывать системные сообщения',
  dont_show_system_messages: 'Скрывать системные сообщения',
  logged_in: 'Арендатор аутентифицирован',
  logged_out: 'Анонимный пользователь',
  button_tooltip_switch_locale: 'Переключить локаль',
  button_tooltip_activate_voice_recognition:
    'Активировать распознавание голоса',
  date_input: 'Выберите дату',
  choose_two_dates: 'Пожалуйста, выберите две даты',
  date_range: 'Диапазон дат',
  from: 'с сайта',
  to: 'на',
  avatar: 'Аватар',
  exit: 'Выход',
  new: 'Новый',
  back: 'Назад',
  address: 'Адрес',
  suggestions: 'Предложения',
  senton: 'Отправлено',
  message_placeholder: 'Введите ваше сообщение здесь...',
  message_aria: 'Введите ваше сообщение здесь',
  upload_in_progress: 'Загрузка идёт...',
  comment_placeholder: 'Введите комментарий здесь',
  message_button_label: 'Отправить',
  please_confirm: 'Пожалуйста, подтвердите',
  no: 'Нет',
  yes: 'Да',
  modal_delete_session: 'Удалить сессию',
  modal_delete_session_notification:
    'Если вы закроете окно, ваша сессия также будет удалена.<br> Вы согласны с этим?',
  template_contact_time: 'Когда мы можем с вами связаться?',
  template_pause:
    'Ваша сессия была приостановлена. Один из наших сотрудников службы поддержки займется вашим запросом в ближайшее время',
  template_continue_after_pause:
    'Ваша сессия продолжилась. Теперь вы можете продолжить переписку с нашим чатботом.',
  choose_date: 'Пожалуйста, выберите дату',
  button_apply: 'Применить',
  button_cancel: 'Отменить',
  none: 'Нет',
  book_appointment: 'Забронировать назначение',
  address_input: 'Ввод адреса',
  data_processing: 'Обработка данных',
  privacy_policy: 'Политика конфиденциальности',
  data_processing_notification_before_link:
    'Для использования этого сервиса чата необходимо, чтобы вы приняли ',
  data_processing_notification_after_link: '.',
  button_accept: 'Принять',
  select_date: 'Дата выбора',
  rate_conversation: 'Как бы вы оценили этот разговор?',
  new_ticket_question: 'Могу ли я вам еще чем-нибудь помочь?',
  thank_you:
    'Спасибо за вашу поддержку. Ваши отзывы помогают мне постоянно совершенствоваться',
  goodbye: 'До свидания',
  start_new: 'Начать новый разговор',
  operator_entered_the_chat: 'Оператор вошел в чат',
  operator_left_the_chat: 'Оператор покинул чат',
  bg_image: process.env.VUE_APP_EN_BG,
  expand_quickreplies: 'Больше',
  collapse_quickreplies: 'Меньше',
  login: 'Войти',
  logout: 'Выйти',
  close: 'Закрыть',
  messenger_text: 'У вас есть вопрос? Мы будем рады помочь вам!',
  chat_bot: 'Чат-бот',
  live_bot: 'Чат',
  maximize: 'максимизировать',
  minimize: 'Минимизировать',
  tooBig: 'Файл слишком большой',
  tooSmall: 'Файл слишком мал',
  invalidFileTypeCopilot:
    'Недопустимый тип файла. В настоящее время поддерживаются только типы файлов .png, .jpg, .jpeg, .gif.',
  tooManyFiles: 'Пожалуйста, загрузите максимум 5 файлов одновременно',
  chatProtocol: 'ПротоколЧата',
  showMore: 'Показать больше',
  showLess: 'Показать меньше',
  uploadTooltip: 'Загрузить файл',
  uploadFilesTooltip: 'Загрузка файлов',
  pdfDownloadTooltip: 'Скачать Разговор',
  feedbackDescription: 'Отзывы для нас',
  feedbackSubtitle: {
    description:
      'Здесь вы можете направить нам общие предложения, пожелания и просьбы.',
    note: 'Обратите внимание, что мы не можем ответить на них.',
    hint:
      'Все остальные вопросы, которые касаются конкретно вашего проживания или поиска квартиры, вы можете изложить нам в чате.'
  },
  feedbackPlaceholder: 'Введите ваше сообщение здесь...',
  sendFeedback: 'Отправить',
  giveFeedback: 'Отзывы для нас',
  feedbackSubmittedSuccessfully: 'Ваш отзыв был успешно отправлен',
  character_limit: 'Символы',
  page: 'p.',
  factually_incorrect: 'Не фактически верно',
  not_following_instructions: 'Не полностью следовал инструкциям',
  info_not_in_document: 'Информация не из документа',
  inappropriate_or_offensive: 'Неуместно или оскорбительно',
  irrelevant: 'Не Связано',
  not_fitting_topic: 'Не соответствует теме',
  confusing_information: 'Мешающая информация',
  ignored_important_parts_of_document: 'Игнорирование важных частей документа',
  interpreted_document_wrong: 'Неправильное толкование документа',
  answer_to_generic: 'Слишком общий ответ',
  sources_incorrect: 'Ненадежные источники или неверно процитированные',
  upload_file: 'Перетащите файл сюда для загрузки',
  upload_file_or: 'или',
  Upload_file_select: 'Добавить файлы',
  upload_file_text: 'Перетащите файл для загрузки',
  show_attachments: 'Показать вложение',
  hide_attachments: 'Скрыть вложение',
  feedbackInfoPlaceholder: 'Не стесняйтесь добавлять конкретные детали здесь...',
  why_not_helpful: 'Почему это не было полезно?',
  thank_you_feedback: 'Спасибо за ваш отзыв!',
  provide_feedback: 'Оставить отзыв на этот ответ',
  not_helpful: 'Не полезно',
  helpful: 'Полезно',
  regenerate_message: 'Регенерировать',
  copy_message: 'Копировать',
  copied_message: 'Скопировано!',
  original_answer: 'Оригинальный ответ',
  regenerated_answer: 'Регенерированный ответ',
  thinking_message: 'Я думаю...',
  file_path: 'Путь к файлу: ',
  new_messages: 'Новые сообщения',
  previous_message: 'Предыдущее сообщение',
  next_message: 'Следующее сообщение',
  clear_input: 'Очистить ввод',
  open_feedback: 'Открыть отзыв',
  file_upload: 'Загрузка файла',
  expand_quickreplies_aria: 'Показать больше кнопок',
  button_tooltip_switch_locale_german: 'Сменить язык на немецкий',
  button_tooltip_switch_locale_french: 'Сменить язык на французский',
  button_tooltip_switch_locale_dutch: 'Сменить язык на нидерландский',
  button_tooltip_switch_locale_turkish: 'Сменить язык на турецкий',
  button_tooltip_switch_locale_russian: 'Сменить язык на русский',
  button_tooltip_switch_locale_swedish: 'Сменить язык на шведский',
  button_tooltip_switch_locale_ukranian: 'Сменить язык на украинский',
  button_tooltip_switch_locale_spanish: 'Сменить язык на испанский',
  button_tooltip_switch_locale_polish: 'Сменить язык на польский',
  button_tooltip_switch_locale_arabic: 'Сменить язык на арабский',
  button_tooltip_switch_locale_italian: 'Сменить язык на итальянский',
  button_tooltip_switch_locale_english: 'Сменить язык на английский',
  message_from_you: 'Вы говорите',
  message_from_bot: 'Бот говорит',
  message_from_operator: 'Агент говорит',
  new_message_from_bot: 'Бот говорит',
  empty_message_received: 'Получено пустое сообщение'
}
